import OTable from './OTable'

export default OTable
